var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "movimentacao container-fluid" },
    [
      _c("ConsultarMovimentacao", {
        attrs: { userList: _vm.userList, ativoId: _vm.ativoId },
        on: { onChangeAtivo: _vm.onChangeAtivo }
      }),
      _vm.ativoSelected
        ? _c(
            "div",
            { staticClass: "container-fluid infos-movimentacao" },
            [
              _c("CaracteristicasProduto", {
                attrs: { ativo_prop: _vm.currentAtivo }
              }),
              _c("MovimentacaoProduto", {
                attrs: {
                  headers: _vm.headers,
                  headers2: _vm.headers2,
                  desserts: _vm.desserts,
                  ativo_prop: _vm.currentAtivoMovimento
                }
              }),
              _c("div", { staticClass: "grafico-desempenho" }, [
                _c("div", { staticClass: "top-grafico" }, [
                  _c("div", { staticClass: "top" }, [
                    _vm._m(0),
                    _c("div", { staticClass: "btns-ativos" }, [
                      _c(
                        "div",
                        { staticClass: "btn-cdi" },
                        [
                          _c("v-switch", {
                            attrs: { checked: "", label: "CDI" },
                            on: {
                              change: function($event) {
                                return _vm.changeSwitch("CDI")
                              }
                            },
                            model: {
                              value: _vm.switchStateCDI,
                              callback: function($$v) {
                                _vm.switchStateCDI = $$v
                              },
                              expression: "switchStateCDI"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "btn-ipca" },
                        [
                          _c("v-switch", {
                            attrs: { label: "IPCA" },
                            on: {
                              change: function($event) {
                                return _vm.changeSwitch("IPCA")
                              }
                            },
                            model: {
                              value: _vm.switchStateIPCA,
                              callback: function($$v) {
                                _vm.switchStateIPCA = $$v
                              },
                              expression: "switchStateIPCA"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "btn-dolar" },
                        [
                          _c("v-switch", {
                            attrs: { label: "DÓLAR" },
                            on: {
                              change: function($event) {
                                return _vm.changeSwitch("DOLAR")
                              }
                            },
                            model: {
                              value: _vm.switchStateDOLAR,
                              callback: function($$v) {
                                _vm.switchStateDOLAR = $$v
                              },
                              expression: "switchStateDOLAR"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "btn-ibovespa" },
                        [
                          _c("v-switch", {
                            attrs: { label: "IBOVESPA" },
                            on: {
                              change: function($event) {
                                return _vm.changeSwitch("IBOVESPA")
                              }
                            },
                            model: {
                              value: _vm.switchStateIBOVESPA,
                              callback: function($$v) {
                                _vm.switchStateIBOVESPA = $$v
                              },
                              expression: "switchStateIBOVESPA"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "flex-between" }, [
                  _c(
                    "div",
                    {
                      staticClass: "grafico",
                      staticStyle: { "overflow-x": "hidden" }
                    },
                    [
                      _c("gBar", {
                        attrs: {
                          chartData: _vm.arrTeste,
                          chartData2: _vm.arrTeste2,
                          options: _vm.options,
                          label: "Indice",
                          label2: "Ativo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "grafico",
                      staticStyle: { "overflow-x": "hidden" }
                    },
                    [
                      _c("gLine", {
                        attrs: {
                          chartData: _vm.arrTeste3,
                          chartData2: _vm.arrTeste4,
                          options: _vm.options,
                          label: "Ativo Acumulado",
                          label2: "Índice Acumulado"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("Gráfico de desempenho")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }